import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { useQuery } from "hooks/useQuery";
import { getStrategyVersions } from "features/Strategy/service";

export const useStrategyVersions = (id, canEditCode = false) => {
  const dispatch = useDispatch();
  const hasReportedError = useRef(false);

  const { isLoading, isError, error, data, refetch } = useQuery({
    key: "strategyVersions",
    queryKey: ["strategyVersions", id],
    queryFn: async () => {
      const response = await getStrategyVersions(id);
      return response;
    },
    // The endpoint 403s without edit rights, so only ask when we may edit.
    enabled: !!id && !!canEditCode,
    // Version state changes on every save and every backtest; never serve it
    // from cache without revalidating.
    staleTime: 0,
  });

  // Nothing else surfaces a failure here: react-query no longer calls the
  // onError callback hooks/useQuery passes it, so a failed fetch is silent.
  useEffect(() => {
    if (!isError || !error) {
      hasReportedError.current = false;
      return;
    }
    if (hasReportedError.current) return;
    hasReportedError.current = true;
    dispatch(toast({ type: "error", body: parseErrorMessage(error) }));
  }, [isError, error, dispatch]);

  return {
    isLoading,
    isError,
    deployedVersion: data?.deployed ?? null,
    pendingVersion: data?.pending ?? null,
    refetch,
  };
};
